import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { AgendaRoutingModule } from './agenda-routing.module';
import { AgendaComponent } from './pages/agenda/agenda.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { MatRadioModule } from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ProximasConsultasDiaComponent } from './components/proximas-consultas-dia/proximas-consultas-dia.component';
import { MarcarConsultaModalComponent } from './components/marcar-consulta-modal/marcar-consulta-modal.component';
import { AgendaHeaderDiaComponent } from './components/agenda-header-dia/agenda-header-dia.component';
import { DetalhesConsultaModalComponent } from './components/detalhes-consulta-modal/detalhes-consulta-modal.component';

registerLocaleData(localePt);

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    SharedModule,
    MatIconModule,
    MatRadioModule,
    AgendaRoutingModule,
    MatAutocompleteModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    })
  ],
  declarations: [
    AgendaComponent,
    ProximasConsultasDiaComponent,
    AgendaHeaderDiaComponent,
    MarcarConsultaModalComponent,
    DetalhesConsultaModalComponent
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    }
  ]
})
export class AgendaModule {}
